/* Independent, accessible content carousels. Purchase and cart code live in theme.js. */
(() => {
  'use strict';
  if (window.pouchContent) return;
  const carousels = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function mount(root) {
    if (carousels.has(root)) return;
    const track = root.querySelector('[data-pp-track]');
    const slides = track ? [...track.querySelectorAll('[data-pp-slide]')] : [];
    const controls = root.querySelector('[data-pp-controls]');
    const dots = root.querySelector('[data-pp-dots]');
    const previous = root.querySelector('[data-pp-prev]');
    const next = root.querySelector('[data-pp-next]');
    const status = root.querySelector('[data-pp-status]');
    if (!track || !slides.length || !controls || !dots || !previous || !next) return;

    const controller = new AbortController();
    let positions = [0];
    let active = 0;
    let frame = 0;
    const goTo = (index) => {
      const position = positions[Math.max(0, Math.min(positions.length - 1, index))];
      track.scrollTo({ left: position, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    };
    const update = () => {
      frame = 0;
      let nearest = 0;
      positions.forEach((position, index) => {
        if (Math.abs(position - track.scrollLeft) < Math.abs(positions[nearest] - track.scrollLeft)) nearest = index;
      });
      active = nearest;
      previous.disabled = active === 0;
      next.disabled = active === positions.length - 1;
      [...dots.children].forEach((dot, index) => {
        dot.classList.toggle('is-active', index === active);
        dot.setAttribute('aria-current', index === active ? 'true' : 'false');
      });
      if (status) status.textContent = `${active + 1} z ${positions.length}`;
    };
    const measure = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      // Measure from the first card, not the padded track: otherwise its 3px
      // padding creates a phantom first page in the review carousel.
      const firstLeft = slides[0].getBoundingClientRect().left;
      const offsets = slides.map((slide) => Math.max(0, Math.min(max, slide.getBoundingClientRect().left - firstLeft)));
      positions = [0, ...offsets, max].filter((value, index, all) => all.findIndex((entry) => Math.abs(entry - value) < 2) === index).sort((a, b) => a - b);
      if (dots.children.length !== positions.length) {
        const buttons = positions.map((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'pp-carousel-dot';
          dot.dataset.ppDot = String(index);
          dot.setAttribute('aria-label', `Pokaż grupę opinii ${index + 1} z ${positions.length}`);
          if (track.id) dot.setAttribute('aria-controls', track.id);
          return dot;
        });
        dots.replaceChildren(...buttons);
      }
      controls.hidden = positions.length < 2;
      update();
    };

    root.addEventListener('click', (event) => {
      const target = event.target.closest('button');
      if (!target || !root.contains(target)) return;
      if (target === previous) goTo(active - 1);
      if (target === next) goTo(active + 1);
      if (target.matches('[data-pp-dot]')) goTo(Number(target.dataset.ppDot));
    }, { signal: controller.signal });
    track.addEventListener('scroll', () => {
      if (!frame) frame = requestAnimationFrame(update);
    }, { passive: true, signal: controller.signal });
    track.addEventListener('keydown', (event) => {
      if (event.target !== track) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(active - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(active + 1); }
      if (event.key === 'Home') { event.preventDefault(); goTo(0); }
      if (event.key === 'End') { event.preventDefault(); goTo(positions.length - 1); }
    }, { signal: controller.signal });
    const observer = new ResizeObserver(measure);
    observer.observe(track);
    slides.forEach((slide) => observer.observe(slide));
    carousels.set(root, () => { controller.abort(); observer.disconnect(); if (frame) cancelAnimationFrame(frame); });
    measure();
  }

  function init(scope = document) {
    if (scope.matches?.('[data-pp-carousel]')) mount(scope);
    scope.querySelectorAll('[data-pp-carousel]').forEach(mount);
    carousels.forEach((cleanup, root) => { if (!root.isConnected) { cleanup(); carousels.delete(root); } });
  }
  window.pouchContent = { init };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    carousels.forEach((cleanup, root) => { if (event.target.contains(root)) { cleanup(); carousels.delete(root); } });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
